<template>
	<div class="aside_right">
		<div class="miuse_wrap">
			<div class="miuse_tit fl_left dan_btn" @click="play($event,index)" v-if="formData.tamplate_id==4"
				:class="{'dbtn0':index==0,'dbtn1':index==1,'dbtn2':index==2,'dbtn3':index==3,'dbtn4':index==4,'dbtn5':index==5,'dbtn6':index==6,'dbtn7':index==7,'dbtn8':index==8,'dbtn9':index==9}"
				v-for="(item,index) in musicList">
				<span>{{item.oldname}}</span>
				<em>{{item.src}}</em>
				<div class="dele_music" @click="dele_mus($event,index)"></div>
			</div>
			<div class="miuse_tep fl_left">
				<span> + 添加音乐</span>
				<input type="file"  @change="fileChanged"  id="file2" accept="audio/mp3">
			</div>
		</div>
		<div class="inf_wrap">
			<div class="inf_add">
			</div>
			<div class="teplate_tit">
				<div @click="saveId"> + 制作内容</div>
			</div>
			<div class="conlist" v-for="(item,key) in inforShow" 
				v-if="formData.tamplate_id==4">
				<div class="list_tit clearfix">
					<div class="tits fl_left">{{item.json_data.bg_title}}</div>
					<div class="music fl_left" v-if="item.json_data.music" v-for="(itemMusic,keyMusic) in item.json_data.music"
						@click="plays($event,key,keyMusic)">
						<div class="music_icon">
							<audio :src="itemMusic.src" class="play"></audio>
						</div>
					</div>
					<div class="bkxq_wrapper fl_right" @click="xq_show($event,key)" v-if="item.have_explain == 1">
						<span>教学详解</span>
					</div>
					<div class="xq_box">
						<div class="xq_conTer">
							<div class="xq_del" @click="xq_hide($event)"></div>
							<div class="xq_list" v-for="(itemBkxq,ky) in inforShow1">
								<div class="clearfix">
									<div class="xqTit fl_left">{{itemBkxq.title}}</div>
									<div class="music fl_left" v-for="(itemMusicq,keysMusic) in itemBkxq.music"
										@click="players($event,key,ky,keysMusic)">
										<div class="music_icon">
											<audio :src="itemMusicq.src" class="play"></audio>
										</div>
									</div>
								</div>
								<div class="xqCon">
									<div v-if="itemBkxq.bg_text" v-html="itemBkxq.bg_text"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="list_wb">
					<div class="wb_con">
						<div class="wb_tit" v-html="item.json_data.bg_text"></div>
					</div>
				</div>
				<div class="editor_dele">
					<el-button icon="el-icon-edit" size="mini" @click="xgContent($event,1,key)" >编辑</el-button>
					<el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteSection(item.id,key)" >删除</el-button>
				</div>
				<!-- <div class="imgsrc" v-for="(items,keys) in item.one_img">
					<img :src="vals" alt="" v-for='(vals,indexs) in items.imgUrl'>
				</div> -->
				<div class="videoSrc">
					<audio src="itemVideo.fileLs" v-for="(itemVideo,keyVideo) in item.one_video"></audio>
				</div>
			</div>
		</div>
		<div class="video_wrap">
			<div class="video_b fl_left" @click="player" v-model="psop"></div>
			<div class="video_con fl_left">
				<div class="miuse_top">
					<div class="mus_TB">
						<div class="mus_tit fl_left">音乐名称</div>
						<div class="mus_time fl_right">
							<span class="starttime">00:00</span> /
							<span class="endtime">00:00</span>
						</div>
						<div class="audis_wrap">
							<audio :src="musicPlay" class="audis" id="audis"></audio>
						</div>
						<div class="fixclear"></div>
					</div>
					<div class="mus_bar">
						<b class="progress-bar" :style="{width:proBar+'%'}"></b>
					</div>
				</div>
			</div>
		</div>
		<form action="" method="post" enctype="multipart/form-data">
			<div v-if="UPload" class="upload_wrap">
				<div class="vue-oss-uploader-video-wrap" style="padding-top: 0;">
					<div class="vue-oss-uploader-video">
						<div class="vue-oss-uploader-video-top">
							<div class="vue-oss-uploader-video-top-left">音乐</div>
							<div class="vue-oss-top-closes" @click="Buttonclosez()">×</div>
						</div>
						<div class="vue-oss-uploader-video-top-btn clearfixed">
							<div class="video-btn-local fl_left video-btn" @click="add" v-if="status == 'ready'">上传音乐
							</div>
							<div class="mark_wrap_loading"></div>
						</div>
						<div class="vue-oss-uploader-video-content">
							<div class="video-top-head clearfixed">
								<div class="fl_left video-sele-z">选择</div>
								<div class="fl_left video-sele-name">名称</div>
								<div class="fl_left video-sele-ntime">更新时间</div>
								<div class="fl_left video-sele-time">时长</div>
							</div>
							<div style="position:relative;">
								<div class="oss-video clearfixed" v-if="musicurl" v-for=" (item,key) in files"
									@click="selectMusic(key)">
									<div class="fl_left video-sele-z"><span class="checkedbox"></span>
										<div class="mark"><i class="el-icon-check"></i></div>
									</div>
									<div class="fl_left video-sele-name">{{item.name}}</div>
									<div class="fl_left video-sele-ntime">{{item.file.lastModifiedDate}}</div>
									<div class="fl_left video-sele-time">00:00:25</div>
									<div class="loading-wrap">
										<div id="progress_bar">
											<div class="fl_left progress_length"><input disabled
													:style="{width:progrees+'%'}" type="text"></div>
											<span class="fl_right uploadNum">已上传：0%</span>
										</div>
									</div>
								</div>
								<div class="oss-loading-mark-wrap"></div>
							</div>
						</div>
						<div class="videoBtn_wrap">
							<div class="videoBtn" @click="checkMusic">确定</div>
							<div class="mark_btn">上传中<img src="../../../../static/imgs/loading.gif" alt=""></div>
						</div>
						
					</div>
				</div>
			</div>
		</form>
		<div class="mark_wrap" v-if="lmcon">
			<div class="tishi_Infor">
				<div class="tishi_con">请先添加左侧栏目</div>
				<div class="tishi_btn" @click="sure">确定</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				lmcon: false,
				status: 'ready',
				UPload: false,
				psop: 0,
				proBar: 0,
				inforShow: [],
				toId: null,
				toId2: [],
				inforShow1: [],
				XQtoId: null,
				cxID: '',
				musicList: [],
				musicurl: [],
				Musicsrc: '',
				bdmusicsrc: '',
				musicName: '',
				files: [],
				musicPlay: '',
				zMusic: [],
				xgCon: null,
				cMusic: [],
				num: 0,
				progrees: 0,
				music_state: 0,
				currentAjax: null,
				dete: [],
				musicplay: 0,
				oldKey:'',
			}
		},
		updated() {
			// this.musicList=this.dete
		},
		props: ['formData'],
		methods: {
			// xgContent(e, i) {
			// 	e.stopPropagation();
			// 	const _this = this;
			// 	var tep_crey = JSON.stringify(this.formData)
			// 	window.localStorage.setItem('template', tep_crey);
			// 	if (sessionStorage.getItem('changeName') == null) {
			// 		sessionStorage.setItem('formID', JSON.stringify({ crey: _this.formData.creyId, conId: _this.xgCon[i].id }))
			// 		_this.formData.creyId = _this.$md5("'" + _this.formData.creyId + "'")
			// 		_this.xgCon[i].id = _this.$md5("'" + _this.xgCon[i].id + "'")
			// 		_this.$router.push({
			// 			path: '/addCategory/formDate',
			// 			name: 'formDate',
			// 			query: {
			// 				crey: _this.formData.creyId,
			// 				conId: _this.xgCon[i].id,
			// 			}
			// 		})
			// 	} else {
			// 		sessionStorage.setItem('formID', JSON.stringify({ crey: parseInt(sessionStorage.getItem('changeName')), conId: _this.xgCon[i].id }))
			// 		var list = _this.$md5(sessionStorage.getItem('changeName'))
			// 		_this.xgCon[i].id = _this.$md5("'" + _this.xgCon[i].id + "'")
			// 		_this.$router.push({
			// 			path: '/addCategory/formDate',
			// 			name: 'formDate',
			// 			query: {
			// 				crey: list,
			// 				conId: _this.xgCon[i].id,
			// 			}
			// 		})
			// 	}
			// },
			xgContent(e,val,i){
				e.stopPropagation();
				if(val == 2) return 
				const _this = this;
				var tep_crey=JSON.stringify(this.formData)
				localStorage.setItem('template',tep_crey);

				if(sessionStorage.getItem('changeNum') == null){
					// var tep_crey=JSON.stringify(this.formData);
					sessionStorage.setItem('formID',JSON.stringify({crey:_this.formData.module_id,conId:_this.inforShow[i].id}))
					_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);
			 		_this.$router.push({
						path:'/manager/stu_class/class/singleLesson/addKj/makTep/startFrom',
						name:'wz',
						query:{
							package:this.$route.query.package,
							id:this.$route.query.id,
							table_id:this.$route.query.table_id,
							pocId:this.$route.query.pocId,
						}
					})
				}else{
					sessionStorage.setItem('formID',JSON.stringify({crey:parseInt(sessionStorage.getItem('changeNum')),conId:_this.inforShow[i].id}))
					this.formData.module_id=parseInt(sessionStorage.getItem('changeNum'))
					// var tep_crey=JSON.stringify(this.formData);
					_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);
			 		_this.$router.push({
						path:'/manager/stu_class/class/singleLesson/addKj/makTep/startFrom',
						name:'wz',
						query:{
							package:this.$route.query.package,
							id:this.$route.query.id,
							table_id:this.$route.query.table_id,
							pocId:this.$route.query.pocId,
						}
					})
				}
			},
			//删除段
			deleteSection(section_id,key){
				let _this=this;
				_this.$confirm('确认删除此段落吗？此操作不可恢复，请确认', '删除提示', {
					onfirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.$axios.post('deletedetail',{
						detail_id:section_id
					}).then((res)=>{
						if(res.data.code == 200)
						{
							_this.$message({type: 'success',message: '删除成功!'});
							this.inforShow.splice(key,1);
						}else{
							_this.$message.error(res.data.message)
						}
					}).catch((err)=>{
						console.log(err)
					})
				}).catch((error) => {     
				});	
			},
			selectMusic(i) {
				$('.oss-video').eq(i).find('.video-sele-z').children('.mark').show().parent().parent().siblings().find('.video-sele-z').children('.mark').hide();
				this.num = i;
				this.time = new Date().getTime()
			},
			checkMusic(){
				this.uploadByOss(this.files[0]);
			},
			random_string(len) {
                len = len || 32;
                var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
                var maxPos = chars.length;
                var pwd = "";
                for (var i = 0; i < len; i++) {
                    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                }
                return pwd;
            },
			 //阿里云上传
			 uploadByOss(file) {
                let _this = this;
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var fileurl = new Date().getTime() + _this.random_string(16) + '.' + file.name.split('.')[1]
                return new Promise(function (resolve, reject) {  // Promise 一定要在函数的最外层才有效
                    _this.$axios.post('gettablepolicyaction',{table_id:_this.formData.table_id}).then(function (res) {
                        var re = res.data.data;
                        var osssignature = {
                            'key': re.dir + fileurl,
                            'policy': re.policy,
                            'OSSAccessKeyId': re.accessid,
                            'success_action_status': '200',
                            'signature': re.signature,
                            'callback': re.callback,
                        };
                        var formData = new FormData()
                        for (var k in osssignature) {
                            formData.append(k, osssignature[k])
                        }
                        //var suffix = _this.get_suffix(file.type); // 获取文件扩展名
                        formData.append("key", re.dir);
                        formData.append('file', file)  // 必须放最后
                        var xhr = new XMLHttpRequest()
                        //xhr.upload.addEventListener('progress', uploadProgress, false)
                        xhr.open('POST', re.host, true)
                        xhr.send(formData)
                        xhr.onload = () => {
                            if (xhr.status === 200 || xhr.status === 304) {
								loading.close();
								_this.musicList.push({name:fileurl,src:xhr.responseURL + re.dir + fileurl,url:'../../media/'+fileurl,oldname:file.name})
								_this.add_column_music()
                            } else {
                                console.log(`error：error code ${xhr.status}`)
                            }
                        }
                    })
                })
			},
			
			add_column_music(){
				let _this = this;
				_this.$axios.post('addcolumnmusic',{column_id:this.formData.module_id,music:_this.musicList}).then( res =>{
					if(res.data.code == 200){
						// _this.$message.success('添加成功')
					}
					else{
						_this.$message.error(res.data.message)
					}
				}).catch( error =>{
					console.log(error)
				})
			},

            
			// checkMusic() {
			// 	var _this = this;
			// 	if (this.files.length <= parseInt(sessionStorage.getItem('NumLength'))) {
			// 		_this.musicList.push({ 'src': this.files[_this.num].src, 'name': this.files[_this.num].name, 'url': this.files[_this.num].url })

			// 		if (sessionStorage.getItem('changeName') == null) {
			// 			_this.$axios.post('addmusic', {
			// 				id: _this.formData.creyId,
			// 				cery_right: JSON.stringify(_this.musicList)
			// 			}).then(({ data: { data } }) => {
			// 				this.dete = eval('(' + data + ')')
			// 				_this.musicList = eval('(' + data + ')')
			// 				//console.log(_this.musicList)
			// 			})
			// 		} else {
			// 			_this.$axios.post('addmusic', {
			// 				id: parseInt(sessionStorage.getItem('changeName')),
			// 				cery_right: JSON.stringify(_this.musicList)
			// 			}).then(({ data: { data } }) => {
			// 				_this.musicList = eval('(' + data + ')')
			// 			})
			// 		}
			// 		_this.UPload = !_this.UPload;
			// 	} else {
			// 		const fNum = this.files;
			// 		var couse = JSON.parse(sessionStorage.getItem('courseNum'))[1]
			// 		var a = new FormData();
			// 		a.append('file', fNum[this.num].file)
			// 		a.append("course_id", parseInt(couse));
			// 		a.append("package_id", parseInt(this.formData.pocId));
			// 		a.append("less_id", parseInt(this.formData.tabId));
			// 		a.append("file_name", 'audio_' + _this.time);
			// 		a.append("title", fNum[_this.num].name)
			// 		_this.currentAjax = $.ajax({
			// 			type: "post",
			// 			url: "http://manage.kc.ez366.com/v1/upload",      // 北舞正式服
			// 			data: a,
			// 			dataType: 'json',
			// 			processData: false, // 告诉jQuery不要去处理发送的数据
			// 			contentType: false, // 告诉jQuery不要去设置Content-Type请求头
			// 			xhrFields: { withCredentials: true },
			// 			async: true,
			// 			xhr: function () {
			// 				const myXhr = $.ajaxSettings.xhr();
			// 				if (myXhr.upload) {
			// 					myXhr.upload.addEventListener('progress', function (e) {
			// 						//console.log(e.lengthComputable)
			// 						if (e.lengthComputable) {
			// 							var percent = Math.floor(e.loaded / e.total * 100);
			// 							if (percent <= 100) {
			// 								$('.vue-oss-uploader-video-wrap').find('.oss-video').eq(_this.num).find('.loading-wrap').css({ "display": "flex" }).parent().siblings().find('.loading-wrap').hide();
			// 								$("#progress_bar span").html('已上传：' + percent + '%');
			// 								$('.mark_btn').css({ 'display': 'flex' })
			// 								$('.oss-loading-mark-wrap').show()
			// 								$('.mark_wrap_loading').show()
			// 								_this.progrees = percent;
			// 							}
			// 						}
			// 					}, false);
			// 				}
			// 				return myXhr;
			// 			},
			// 			success: function ({ data }, status) {
			// 				_this.musicList.push({ 'src': data, 'name': fNum[_this.num].name, 'url': '../../media/audio_' + _this.time + '.mp3' })

			// 				var Couse = parseInt(JSON.parse(sessionStorage.getItem('courseNum'))[1])
			// 				var Package = parseInt(JSON.parse(sessionStorage.getItem('lessonInfor')).pocId)
			// 				if (sessionStorage.getItem('changeName') == null) {
			// 					_this.$axios.post('addmusic', {
			// 						id: _this.formData.ceryID,
			// 						cery_right: JSON.stringify(_this.musicList)
			// 					}).then(({ data }) => {
			// 						_this.dete = eval('(' + data.data + ')')
			// 						_this.musicList = eval('(' + data.data + ')')
			// 						_this.$axios.post('getAllMedia', {
			// 							type: 'audio',
			// 							course_id: Couse,
			// 							package_id: Package
			// 						}).then(({ data: { data } }) => {
			// 							_this.files = [];
			// 							for (var i = 0; i < data.length; i++) {
			// 								_this.files.push({
			// 									name: data[i].media_title,
			// 									file: { lastModifiedDate: data[i].updated_at },
			// 									src: data[i].res_url,
			// 									url: '../../media/' + data[i].new_file_name
			// 								})
			// 							}
			// 							sessionStorage.setItem('NumLength', _this.files.length)
			// 						})
			// 					})
			// 				} else {
			// 					_this.$axios.post('addmusic', {
			// 						id: parseInt(sessionStorage.getItem('changeName')),
			// 						cery_right: JSON.stringify(_this.musicList)
			// 					}).then(({ data }) => {
			// 						_this.dete = eval('(' + data.data + ')')
			// 						_this.musicList = eval('(' + data.data + ')')
			// 						_this.$axios.post('getAllMedia', {
			// 							type: 'audio',
			// 							course_id: Couse,
			// 							package_id: Package
			// 						}).then(({ data: { data } }) => {
			// 							_this.files = [];
			// 							for (var i = 0; i < data.length; i++) {
			// 								_this.files.push({
			// 									name: data[i].media_title,
			// 									file: { lastModifiedDate: data[i].updated_at },
			// 									src: data[i].res_url,
			// 									url: '../../media/' + data[i].new_file_name
			// 								})
			// 							}
			// 							sessionStorage.setItem('NumLength', _this.files.length)
			// 						})
			// 					})
			// 				}

			// 				$('.mark_btn').hide()
			// 				$('.oss-loading-mark-wrap').hide()
			// 				$('.mark_wrap_loading').hide()
			// 				$('.loading-wrap').hide();
			// 				_this.UPload = !_this.UPload;
			// 			},
			// 			error: function (data) {
			// 				console.log(data);
			// 			},
			// 		})
			// 	}
			// },
			Buttonclosez() {
				const _this = this;
				if (_this.currentAjax == null) {
					_this.UPload = !_this.UPload;
				} else {
					_this.currentAjax.abort();
					$('.mark_btn').hide()
					$('.oss-loading-mark-wrap').hide()
					$('.mark_wrap_loading').hide()
					$('.loading-wrap').hide();
					_this.UPload = !_this.UPload;
				}
			},
			add() {
				var _this = this;
				_this.$refs.file.click();
			},
			sure() {
				this.lmcon = !this.lmcon
			},
			fileChanged() {
				var files = document.getElementById('file2');
				var fileLen = document.getElementById('file2').files;
				var filename = $('#file2').val();
				// let num = _this.imgUrls.length;
				// _this.imgUrls[num]=URL.createObjectURL(fileLen[0]);
				this.uploadByOss(fileLen[0]);
				// const list = this.$refs.file.files
				// for (let i = 0; i < list.length; i++) {
				// 	if (!this.isContain(list[i])) {
				// 		const item = {
				// 			name: list[i].name,
				// 			size: list[i].size,
				// 			file: list[i]
				// 		}
				// 		this.html5Reader(list[i], item)
				// 		this.files.unshift(item)
				// 	}
				// }
				// this.$refs.file.value = '';
			},
			// 将图片文件转成BASE64格式
			html5Reader(file, item) {
				const reader = new FileReader()
				reader.onload = (e) => {
					this.$set(item, 'src', e.target.result)
				}
				reader.readAsDataURL(file)
			},
			isContain(file) {
				return this.files.find((item) => item.name === file.name && item.size === file.size)
			},
			xq_hide(e) {
				e.stopPropagation()
				$('.xq_box').hide()
			},
			xq_show(e, i) {
				e.stopPropagation()
				const _this = this;
				$('.xq_box').show()
				_this.$axios.post('getexplainlist',{
					detail_id:_this.inforShow[i].id
				}).then( res =>{
					if(res.data.code == 200){
						_this.inforShow1 = res.data.data.json_data
					}
					else{
						_this.$message.error(res.data.message)
					}
				}).catch( error =>{
					console.log(error)
				})
			},
			saveId(){
				const _this=this;
				var tep_crey=JSON.stringify(this.formData)
				localStorage.setItem('template',tep_crey);
				sessionStorage.removeItem('formID')
				if(sessionStorage.getItem('changeNum')==null){
					// var tep_crey=JSON.stringify(this.formData);
					_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);

					if(_this.formData.lanmu<=0){
				 		_this.lmcon=true;
				 	}else{
				 		_this.lmcon=false;
				 		_this.$router.push({
							path:'/manager/stu_class/class/singleLesson/addKj/makTep/startFrom',
							name:'wz',
							query:{
								package:this.$route.query.package,
								id:this.$route.query.id,
								table_id:this.$route.query.table_id,
								pocId:this.$route.query.pocId,
							}
						})
				 	}
				}else{
					this.formData.module_id=parseInt(sessionStorage.getItem('changeNum'))
					// var tep_crey=JSON.stringify(this.formData);
					_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);
					if(_this.formData.lanmu<=0){
				 		_this.lmcon=true;
				 	}else{
				 		_this.lmcon=false;
				 		_this.$router.push({
							path:'/manager/stu_class/class/singleLesson/addKj/makTep/startFrom',
							name:'wz',
							query:{
								package:this.$route.query.package,
								id:this.$route.query.id,
								table_id:this.$route.query.table_id,
								pocId:this.$route.query.pocId,
							}
						})
				 	}
				}
			},
			addMusic() {
				const _this = this;
				if (_this.formData.lanmu <= 0) {
					_this.lmcon = true;
				} else {
					_this.lmcon = false;
					_this.UPload = !_this.UPload;
				}
			},
			play(e, key) {
				const _this = this;
				e.stopPropagation()
				if (typeof ($(document).find('video')[0]) == 'object') {
					$(document).find('video')[0].pause()
				}
				$('div.miuse_tit.fl_left.dan_btn').eq(key).addClass('danclick').siblings().removeClass('danclick')
				this.musicPlay = this.musicList[key].src
				$('.mus_tit').html($('.miuse_tit').eq(key).find('span').html())
				var time = document.getElementById("audis");
				time.oncanplay = function () {
					var minute = parseInt(time.duration / 60);
					var second = Math.round(time.duration % 60);
					if (minute < 10) {
						minute = "0" + minute;
					}
					if (second < 10) {
						second = "0" + second;
					}
					$('.mus_time').find('.endtime').html(minute + ":" + second);
				}
				this.proBar = 0;
				if(_this.oldKey===''){
					_this.psop = 0;
					_this.oldKey=key;
				}
				else{
					if(_this.oldKey!=key){
						_this.psop = 0;
						_this.oldKey=key;
					}
					else{
						// _this.psop = 0;
						_this.oldKey=key;
					}
				}
				// _this.psop = 0
				_this.$nextTick(() => {
					_this.player()

				})

			},
			plays(e, i, j) {
				if (typeof ($(document).find('video')[0]) == 'object') {
					$(document).find('video')[0].pause()
				}
				e.stopPropagation();
				this.psop = 1;
				/*this.player()*/
				if (this.music_state) {
					$('.conlist').eq(i).find('.music').eq(j).find('.play').get(0).pause()
					this.music_state = 0;
					$('.conlist').eq(i).find('.music').eq(j).find('.music_icon').removeClass('zcir');
				} else {
					/*$('video')[0].pause()*/
					$('.conlist').eq(i).find('.music').eq(j).find('.play').get(0).play().then((res) => {
						this.music_state = 1
						$('.conlist').eq(i).find('.music').eq(j).find('.music_icon').addClass('zcir')
					})
				}
			},
			players(e, i, j, l) {
				if (typeof ($(document).find('video')[0]) == 'object') {
					$(document).find('video')[0].pause()
				}
				e.stopPropagation();
				this.psop = 1;
				/*	this.player()*/
				if (this.music_state) {
					$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.play').get(0).pause()
					this.music_state = 0;
					$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.music_icon').removeClass('zcir');
				} else {
					$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.play').get(0).play().then((res) => {
						this.music_state = 1
						$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.music_icon').addClass('zcir')
					})
				}
			},
			player() {
				if (typeof ($(document).find('video')[0]) == 'object') {
					$(document).find('video')[0].pause()
				}
				var time = document.querySelectorAll(".audis_wrap audio");
				var starttime = document.querySelector('.starttime');
				if (this.psop) {
					$('.audis').get(0).pause();
					this.psop = 0;
					$('.video_b').removeClass('pause');
				} else {
					$('.audis').get(0).play();
					$('.video_b').addClass('pause');
					this.psop = 1;
					$('.audis').on('timeupdate', function () {
						for (var i = 0; i < time.length; i++) {
							var minutes = parseInt(time[i].currentTime / 60);
							var seconds = Math.round(time[i].currentTime % 60);
							if (minutes < 10) {
								minutes = "0" + minutes;
							}
							if (seconds < 10) {
								seconds = "0" + seconds;
							}
							$('.starttime').text(minutes + ":" + seconds);
							this.proBar = $('.progress-bar').width((time[i].currentTime / time[i].duration) * 100 + '%')
							if (this.proBar == 100) {
								$('.audis').get(0).pause();
								$('.video_b').removeClass('pause');
								this.proBar = 0
							}
						}
					});
				}
			},
			dele_mus(e, i) {
				const _this = this;
				e.stopPropagation();
				_this.$confirm('是否删除该歌曲?', '提示', {
					onfirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.musicList.splice(i,1)
					_this.add_column_music()
					_this.$message({
						type: 'success',
						message: '删除成功'
					});
				
				}).catch( error =>{

				})
				// var couse = JSON.parse(sessionStorage.getItem('courseNum'))[1]
				// var template = JSON.parse(localStorage.getItem('template'))
				// var list = JSON.parse(sessionStorage.getItem('lessonInfor'))
				// _this.$confirm('是否删除该歌曲?', '提示', {
				// 	onfirmButtonText: '确定',
				// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(() => {
				// 	_this.$axios.post('unhavemusic', {
				// 		course_id: parseInt(couse),
				// 		package_id: parseInt(list.pocId),
				// 		left_id: parseInt(_this.formData.creyId),
				// 		music_num: i
				// 	}).then(({ data }) => {
				// 		if (data.code == 200) {
				// 			_this.musicList.splice(i, 1)
				// 			_this.$message({
				// 				type: 'success',
				// 				message: '删除成功!'
				// 			});
				// 			_this.$axios.post('modlist', {
				// 				table_id: parseInt(JSON.parse(sessionStorage.getItem('lessonInfor')).table_id)
				// 			}).then(({ data: { data } }) => {
				// 				_this.musicList = []
				// 				if (sessionStorage.getItem('changeName') == null) {
				// 					for (var i = 0; i < data.length; i++) {
				// 						if (data[i].id == _this.formData.creyId) {
				// 							if (data[i].cery_right != '') {
				// 								var arr = eval('(' + data[i].cery_right + ')')
				// 								for (var j = 0; j < arr.length; j++) {
				// 									_this.musicList.push(arr[j])
				// 								}
				// 							}
				// 						}
				// 					}
				// 				} else {
				// 					for (var i = 0; i < data.length; i++) {
				// 						if (data[i].id == parseInt(sessionStorage.getItem('changeName'))) {
				// 							if (data[i].cery_right != '') {
				// 								var arr = eval('(' + data[i].cery_right + ')')
				// 								for (var j = 0; j < arr.length; j++) {
				// 									_this.musicList.push(arr[j])
				// 								}
				// 							}
				// 						}
				// 					}
				// 				}

				// 			})
				// 		} else {
				// 			_this.$message.error(data.message)
				// 		}
				// 	})
				// }).catch(() => {
				// 	_this.$message({
				// 		type: 'info',
				// 		message: '已取消'
				// 	});
				// });
			},
			changeCON() {
				const _this = this;
				console.log(this.formData)
				
				_this.$axios.post('getdetaillist',{
					column_id:_this.formData.module_id
				}).then( res =>{
					if(res.data.code == 200){
						_this.inforShow = res.data.data
					}
					else{
						_this.$message.error(res.data.message)
					}
				}).catch( error =>{
					console.log(error)
				})
			}
		},
		created() {
			const _this = this;
			this.musicList = this.formData.music
			console.log(this.musicList)
			_this.changeCON()
			// _this.$axios.post('getAllMedia', {
			// 	type: 'audio',
			// 	course_id: Couse,
			// 	package_id: Package
			// }).then(({ data: { data } }) => {
			// 	for (var i = 0; i < data.length; i++) {
			// 		_this.files.push({
			// 			name: data[i].media_title,
			// 			file: { lastModifiedDate: data[i].updated_at },
			// 			src: data[i].res_url,
			// 			url: '../../media/' + data[i].new_file_name
			// 		})
			// 	}
			// 	sessionStorage.setItem('NumLength', this.files.length)
			// })
		},
		watch: {
			formData: {
				handler() {
					var _this = this;
					this.musicList = this.formData.music
					_this.changeCON()
					// _this.$axios.post('modlist', {
					// 	table_id: parseInt(JSON.parse(sessionStorage.getItem('lessonInfor')).table_id)
					// }).then(({ data: { data } }) => {
					// 	_this.musicList = []
					// 	if (sessionStorage.getItem('changeName') == null) {
					// 		for (var i = 0; i < data.length; i++) {
					// 			if (data[i].id == _this.formData.creyId) {
					// 				if (data[i].cery_right != '') {
					// 					var arr = eval('(' + data[i].cery_right + ')')
					// 					for (var j = 0; j < arr.length; j++) {
					// 						_this.musicList.push(arr[j])
					// 					}
					// 				}
					// 			}
					// 		}
					// 	} else {
					// 		for (var i = 0; i < data.length; i++) {
					// 			if (data[i].id == parseInt(sessionStorage.getItem('changeName'))) {
					// 				if (data[i].cery_right != '') {
					// 					var arr = eval('(' + data[i].cery_right + ')')
					// 					for (var j = 0; j < arr.length; j++) {
					// 						_this.musicList.push(arr[j])
					// 					}
					// 				}
					// 			}
					// 		}
					// 	}
					// })
				},
				deep: true
			},
			musicList: {
				handler() {
					if (this.musicList.length >= 10) {
						$('.miuse_tep').hide()
					} else {
						$('.miuse_tep').show()
					}
				},
				deep: true
			}
		}
	};
</script>
<style scoped>
	.aside_right {
		width: 830px;
		box-sizing: border-box;
		min-height: 581px;
		overflow:auto;
		background: rgba(230, 175, 169, 0.95);
		/*cursor:not-allowed*/
		/* padding:20px 0 0 32px; */
		position: relative;
		font-size: 18px;
		overflow-y: auto;
	}

	.miuse_wrap {
		width: 100%;
		box-sizing: border-box;
		padding-left: 32px;
		padding-top: 30px;
		height: 162px;
		background: #fff;
	}

	.miuse_tit {
		margin: 0 5px;
		overflow: hidden;
		line-height: 1.2;
		padding: 13px 10px;
		width: 142px;
		height: 43px;
		border-radius: 8px;
		box-sizing: border-box;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin-bottom: 20px;
		/*border:1px solid #ffbe70;*/
		/*color: #ffbe70; */
		text-align: center;
		cursor: pointer;
		position: relative;
	}

	.miuse_tep {
		width: 142px;
		height: 43px;
		margin-bottom: 8px;
		box-sizing: border-box;
		border: 1px solid #ffbe70;
		border-radius: 8px;
		color: #ffbe70;
		line-height: 43px;
		text-align: center;
		margin-left: 5px;
		cursor: pointer;
		position: relative;
	}

	.inf_wrap {
		/* background: url(../../static/imgs/start1.jpg) 0 0 no-repeat; */
		background: rgba(230, 175, 169, 0.95);
		width: 100%;
		height: 360px;
		background-size: 100% 360px;
		box-sizing: border-box;
		padding-left: 32px;
		padding-top: 20px;
		overflow: auto;
		color: #fff;
	}

	.inf_wrap::-webkit-scrollbar {
		width: 4px;
		height: 4px;
	}

	.inf_wrap::-webkit-scrollbar-thumb {
		border-radius: 5px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}

	.inf_wrap::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}

	.teplate_tit {
		width: 148px;
		height: 44px;
		box-sizing: border-box;
		line-height: 44px;
		text-align: center;
		color: #fff;
		border-radius: 6px;
		border: 1px dashed #fff;
		cursor: pointer;
	}

	.video_wrap {
		width: 100%;
		height: 66px;
		background: #f7f7f7;
		box-sizing: border-box;
		padding-left: 59px;
		z-index: -1;
		position: absolute;
		top: 0;
		left: 0;
	}

	.video_b {
		width: 35px;
		height: 66px;
		background: url(../../../../static/imgs/play.png) center center no-repeat;
		background-size: 100%;
		cursor: pointer;
	}

	.video_con {
		width: 736px;
		height: 66px;
		box-sizing: border-box;
		padding-left: 25px;
		background: url(../../../../static/imgs/bg_audio.png) right center no-repeat;
		background-size: 90px;
	}

	.mus_TB {
		width: 582px;
		height: 44px;
		line-height: 44px;
		color: #8c94cc;
		font-size: 14px;
	}

	.fixclear {
		width: 0;
		height: 0;
		overflow: hidden;
		clear: both;
	}

	.mus_bar {
		width: 582px;
		height: 14px;
		border-radius: 10px 10px 10px 10px;
		background: #d9d9d9;
		position: relative;
	}

	.pause {
		background: url(../../../../static/imgs/pause.png) center center no-repeat;
		background-size: 100%;
	}

	.progress-bar {
		position: absolute;
		top: 0;
		left: 0;
		display: inline-block;
		width: 0;
		height: 14px;
		border-radius: 10px 10px 10px 10px;
		background: #8c94cc;
	}

	.conlist {
		color: #fff;
		font-size: 22px;
	}

	.zcir {
		animation: go 1.2s infinite;
		animation-fill-mode: both;
	}

	@keyframes go {
		from {
			transform: rotateZ(0);
		}

		to {
			transform: rotateZ(360deg);
		}
	}


	.vue-oss-uploader-video-wrap {
		width: 592px;
		height: 459px;
		border: 1px solid #fafafa;
		position: fixed;
		top: 50%;
		left: 50%;
		background: #fff;
		transform: translateX(-50%) translateY(-50%);
		z-index: 1111;
		border: 1px solid rgba(0, 0, 0, 0.2);
	}

	.vue-oss-uploader-video {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.vue-oss-uploader-video-top {
		position: relative;
		border-bottom: 1px solid rgba(0, 0, 0, 0.2);
	}

	.vue-oss-uploader-video-top-left {
		background: url(../../../../static/imgs/dialog-title-bg.png) repeat-x bottom;
		height: 26px;
		padding-left: 5px;
		line-height: 26px;
	}

	.vue-oss-top-closes {
		width: 20px;
		height: 20px;
		position: absolute;
		right: 10px;
		top: 3px;
		border-radius: 50%;
		border: 1px solid rgba(0, 0, 0, 0.2);
		cursor: pointer;
		box-sizing: border-box;
		text-align: center;
		line-height: 18px;
	}

	.vue-oss-top-closes:hover {
		background: #595db5;
		color: #fff;
	}

	.video-btn {
		width: 70px;
		height: 30px;
		background: #fafafa;
		border-radius: 4px;
		border: 1px solid #fafafa;
		line-height: 30px;
		text-align: center;
		margin: 5px;
		background: url(../../../../static/imgs/dialog-title-bg.png) repeat-x bottom;
		cursor: pointer;
	}

	.vue-oss-uploader-video-content {
		width: 100%;
		height: 330px;
		overflow: auto;
	}

	.vue-oss-uploader-video-content::-webkit-scrollbar {
		width: 4px;
		height: 4px;
	}

	.vue-oss-uploader-video-content::-webkit-scrollbar-thumb {
		border-radius: 5px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}

	.vue-oss-uploader-video-content::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}

	.videoBtn {
		height: 32px;
		width: 132px;
		text-align: center;
		line-height: 32px;
		background: #595db5;
		color: #fff;
		cursor: pointer;
	}

	.videoInput {
		width: 70px;
		height: 30px;
		opacity: 0;
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
	}

	.video-top-head {
		width: 580px;
		margin: 10px auto 0;
		height: 32px;
		background: #f4f4f4;
		font-size: 14px;
		color: #333;
	}

	.video-sele-z,
	.video-sele-num,
	.video-sele-time {
		width: 90px;
		text-align: center;
		line-height: 32px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin: 0 5px
	}

	.video-sele-z {
		position: relative;
	}

	.mark {
		width: 14px;
		height: 14px;
		line-height: 14px;
		color: #595DB5;
		position: absolute;
		top: 10px;
		left: 38px;
		z-index: 999;
		display: none;
	}

	.video-sele-name {
		color: #595DB5;
	}

	.video-sele-name,
	.video-sele-ntime {
		line-height: 32px;
		text-align: center;
		width: 174px;
		margin: 0 5px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.checkedbox {
		width: 16px;
		height: 16px;
		border: 1px solid #d3d5d9;
		display: inline-block;
		vertical-align: middle;
	}

	.oss-video {
		border: 1px solid #f4f4f4;
		border-top: 0;
		width: 580px;
		margin: 0 auto;
		box-sizing: border-box;
		cursor: pointer;
		position: relative;
	}

	.image-show {
		width: 200px;
		height: 136px;
		cursor: pointer;
		margin-bottom: 20px;
		margin-left: 10px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.dele_music {
		position: absolute;
		top: 0;
		right: 0;
		background: #fff url(../../../../static/imgs/quxiao.png) center center no-repeat;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		display: none;
	}

	.miuse_tit:hover .dele_music {
		display: block;
	}

	.music {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 45px;
	}

	.music_icon {
		background: url(../../../../static/imgs/icon_music.png) 0 center no-repeat;
		background-size: 100%;
		width: 28px;
		height: 28px;
		float: left;
		margin-left: 14px;
		cursor: pointer;
	}

	.music_icon audio {
		display: none;
	}

	.bkxq_wrapper {
		height: 30px;
		line-height: 30px;
		padding: 0 10px;
		text-align: center;
		color: #f095b9;
		border-radius: 4px;
		border: 1px solid #f095b9;
		background: #fff;
		margin-top: 8px;
		cursor: pointer;
		margin-right: 20px;
	}

	.xq_box {
		position: absolute;
		top: 0;
		left: 0;
		width: 830px;
		height: 542px;
		overflow:auto;
	/*	background: rgba(230, 175, 169, 0.95);*/
	 	background: url(../../../../static/imgs/startback.png) 0 0 no-repeat; 
		background-attachment: scroll;
		/* box-sizing: border-box; */
		background-size: cover;
		/*padding: 20px 25px 0;*/
		display: none;
		z-index: 99;
	}

	.xq_conTer{
		box-sizing: border-box;
		background: rgba(230, 175, 169, 0.95);
		padding: 20px 25px 0;
		height: 100%;
		overflow-y:auto;
	}
	.xq_conTer::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.xq_conTer::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.xq_conTer::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}

	.xq_del {
		position: absolute;
		top: 20px;
		right: 20px;
		width: 24px;
		height: 24px;
		background: url(../../../../static/imgs/xdel.png) 0 0 no-repeat;
		cursor: pointer;
	}

	.xq_list {
		margin-bottom: 20px;
	}

	.xqTit {
		font-size: 22px;
		line-height: 45px;
		margin-bottom: 10px;
	}

	.xqCon {
		margin-bottom: 10px;
		font-size: 18px;
		/* background: url(../../static/imgs/tn_cir.png) 0 13px no-repeat; */
	}

	#sublime {
		display: none;
	}

	.loading-wrap {
		width: 100%;
		height: 32px;
		position: absolute;
		top: 0;
		left: 0;
		background: rgba(192, 192, 192, 0.5);
		justify-content: center;
		align-items: center;
		display: none;
	}

	#progress_bar {
		width: 100%;
		height: 32px;
		background: rgb(192, 192, 192, 0.5);
	}

	.progress_length {
		width: 100%;
	}

	#progress_bar input {
		border: none;
		outline: none;
		height: 32px;
		width: 0;
		background: #595db5;
	}

	.uploadNum {
		position: absolute;
		top: 0;
		right: 0;
		line-height: 32px;
	}

	.tits {
		height: 45px;
		line-height: 45px;
	}

	.mark_wrap {
		width: 100%;
		height: 100%;
		background: rgb(245, 245, 245, 0.55);
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.tishi_Infor {
		width: 400px;
		height: 150px;
		font-size: 16px;
		background: #fff;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		font-family: "微软雅黑"
	}

	.tishi_btn {
		margin-top: 30px;
		cursor: pointer;
		width: 116px;
		height: 32px;
		background: #595DB5;
		text-align: center;
		line-height: 32px;
		border-radius: 4px;
		color: #fff;
	}

	.clearfixed {
		clear: both;
		content: "";
		display: block;
		overflow: hidden;
	}

	.vue-oss-uploader-video-top-btn {
		position: relative;
	}

	.videoBtn_wrap {
		position: absolute;
		bottom: 20px;
		right: 20px;
		height: 32px;
		width: 132px;
	}

	.mark_btn {
		position: absolute;
		top: 0;
		left: 0;
		width: 132px;
		height: 32px;
		background: rgba(197, 197, 197, 0.9);
		/* display: flex; */
		justify-content: center;
		align-items: center;
		cursor: not-allowed;
		display: none;
	}

	.oss-loading-mark-wrap {
		position: absolute;
		top: 0;
		left: 0;
		background: transparent;
		width: 100%;
		height: 100%;
		display: none;
		cursor: not-allowed;
	}

	.mark_wrap_loading {
		position: absolute;
		top: 5px;
		left: 5px;
		background: transparent;
		width: 70px;
		height: 30px;
		cursor: not-allowed;
		display: none;
	}
	.upload_wrap{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0,0,0,.6);
	}
	.conlist {border: 1px dashed #efefef;}
	.conlist:hover {border: 1px dashed #CCcccc;}
</style>


// WEBPACK FOOTER //
// src/components/index/template/newBwtem.vue